//
// filters.js
//

function filterBy(list, value, key,dis,obj) {
    var newarray = list.filter(function(item) {
        if(key){
            let index = -1;
            key.forEach( (keyItem) => {
                if(item[keyItem] && (item[keyItem].toLowerCase()).indexOf(value.toLowerCase()) > -1){
                    index = (item[keyItem].toLowerCase()).indexOf(value.toLowerCase());
                    return;
                }
            });
            if(Object.values(obj)[0] == "All"){
                if(value && dis){
                    return (index > -1);
                }else if(value && !dis){
                    return ((index > -1) && !item['disabled']);
                }if(value){
                    return index > -1;
                }else if(dis){
                    return list;
                }else if(!dis){
                    return (!item['disabled']);
                }
                else{
                    return list;
                }
            }
            else{
                let str1 = item[Object.keys(obj)[0]];
                if(str1){
                    str1 = str1.toLowerCase();
                }
                const str2 = (Object.values(obj)[0]).toLowerCase();
                if(value && dis){
                    return ((index > -1) && str1 == str2);
                }else if(value && !dis){
                    return ((index > -1) && !item['disabled'] && str1 == str2);
                }if(value){
                    return ((index > -1)  && str1 == str2);
                }else if(dis){
                    return (list  && str1 == str2);
                }else if(!dis){
                    return (!item['disabled'] && str1 == str2);
                }
                else{
                    return list;
                }
            }
        }else if(value){
            return (item.toLowerCase()).indexOf(value.toLowerCase()) > -1;
        }else{
            return list;
        }
  
    });
    return newarray;
  }

function filterByObject(myObject, value) {
    var narray = Object.keys(myObject);
    var newarray = narray.filter(function(item) {

        if(value){
            return (item.toLowerCase()).indexOf(value.toLowerCase()) > -1;
        }else{
            return narray;
        }
    });

    var newObject = {};
    for(var k in newarray){
        newObject[newarray[k]] = myObject[newarray[k]];
    }

    return newObject;
}

function filterByRowInObject(eachObjectRow, key, returnObj={}, nestedObjKey) {
    var returnValue = null;
    for(let eachKey in eachObjectRow) {
        var returnObjKey;
        if (nestedObjKey === undefined) {
            returnObjKey = eachKey;
        } else {
            returnObjKey = nestedObjKey + '.' + eachKey;
        }
        let valueType = eachObjectRow[eachKey] ? typeof(eachObjectRow[eachKey]) : null;
        if (valueType != 'object') {
            returnObj[returnObjKey] =  eachObjectRow[eachKey];
        } else {
            // sending returnObjKey as it's values is object, here returnObjKey => nestedObjKey
            filterByRowInObject(eachObjectRow[eachKey], key, returnObj, returnObjKey);
        }
    }
    returnValue = returnObj[key] || null;
    return returnValue
}

function findBy(list, value) {
    return list.filter(function(item) {
        return item == value
    });
}

function reverse(value) {
    return value.split('').reverse().join('');
}

function limitBy(array, num) {
	array = array.slice(0, num);
	return array;
}

export {filterBy, findBy, reverse, limitBy, filterByObject, filterByRowInObject}